import { render, staticRenderFns } from "./type-ahead.vue?vue&type=template&id=c5f4c2f4&"
import script from "./type-ahead.vue?vue&type=script&lang=js&"
export * from "./type-ahead.vue?vue&type=script&lang=js&"
import style0 from "./type-ahead.vue?vue&type=style&index=0&id=c5f4c2f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports